<template>
  <v-card>
    <v-card-text v-if="otherFields">
      <v-container container--fluid grid-list-md>
        <v-row justify="space-between" align="center">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-text-field
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-container>
      <v-toolbar class="elevation-0" color="white">
        <v-toolbar-title>
          <h3>Contact</h3>
        </v-toolbar-title>

        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-icon class="ml-2" color="orange" v-on="on">fas fa-exclamation-triangle</v-icon>
          </template>
          <span>
            Any modification in the table will be automatically saved (no need to hit the save button of this page)
          </span>
        </v-tooltip>
        <v-spacer></v-spacer>

        <v-dialog width="600px" v-model="newContactDialog">

          <template v-slot:activator="{ on }">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn fab dark color="blue lighten-1" @click="newContactDialog=true" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>New Contact</span>
            </v-tooltip>
          </template>

          <v-card>
            <v-card-title>
              <h3>New Contact</h3>
            </v-card-title>
            <v-divider color="#42a5f5"></v-divider>
            <v-form v-model="valid" ref="newContactForm">
              <v-container container--fluid grid-list-md>
                <v-row justify="space-around">
                  <v-col cols="10" md="4" sm="10">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Contact"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="10" md="4" sm="10">
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Phone"
                      return-masked-value
                      :rules="phoneRule"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="space-around">
                  <v-col cols="10" md="4" sm="10">
                    <v-text-field
                      v-model="editedItem.email"
                      label="Email"
                      :rules="emailRule"></v-text-field>
                  </v-col>
                  <v-col cols="10" md="4" sm="10">
                    <v-subheader>Position</v-subheader>
                    <v-list>
                      <v-list-item @click="" v-for="(position, index) in ['ops', 'cc', 'it', 'billing']" :key="index">
                        <v-list-item-action>
                          <v-checkbox v-model="editedItem[position]"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content @click="editedItem[position]=!editedItem[position]">
                          <v-list-item-title>{{position.charAt(0).toUpperCase() + position.slice(1)}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col cols="3" offset-md-6 class="text-center">
                    <v-btn text color="blue-grey lighten-2" @click="newContactDialog = false">Cancel</v-btn>
                  </v-col>
                  <v-col cols="3" class="text-center">
                    <v-btn
                      text
                      color="blue darken-1"
                      @click="save"
                      :disabled="!valid"
                    >Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card>
        </v-dialog>

      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="contacts"
      >
        <template v-slot:item="props">
          <tr>
            <td v-for="(key, index) in Object.keys(defaultItem)"
                v-if="!['client_name', 'client_id'].includes(key)"
                :key="index" style="text-align: center">
              <v-edit-dialog
                :return-value.sync="props.item[key]"
                large
                persistent
                @save="editSave(props.item)"
                @cancel="this.$store.commit('displaySnackbar', 'Cancelling');"
                @open="email = props.item.email;this.$store.commit('displaySnackbar', 'Editing');"
                @close="this.$store.commit('displaySnackbar', 'Saving change');"
              >
                {{props.item[key]}}
                <template v-slot:input>
                  <v-text-field
                    v-if="key === 'name'"
                    v-model="props.item[key]"
                    label="Edit"
                    :rules="requiredRule"
                    single-line
                    counter
                  ></v-text-field>
                  <v-select
                    v-if="['ops', 'billing', 'it', 'cc'].includes(key)"
                    :items="[{text: 'Yes', value: true}, {text: 'No', value: false}]"
                    v-model="props.item[key]"
                  >
                  </v-select>
                  <v-text-field
                    v-if="key === 'email'"
                    v-model="props.item[key]"
                    :rules="emailRule"></v-text-field>
                  <v-text-field
                    v-if="key === 'phone'"
                    v-model="props.item[key]"
                    :rules="phoneRule"></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td style="text-align: center">
              <v-icon
                small
                @click="openDeleteDialog(props.item)"
                color="red"
              >delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-center">
          You are about to delete contact {{toBeDeleted.name}}
        </v-card-title>
        <v-card-text style="white-space: nowrap">
          Are you sure you want to proceed ? <br>
          This action cannot be undone
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="closeDeleteDialog">No</v-btn>
          <v-btn text color="red" @click="deleteItem">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
    import axios from 'axios'

    // @group EditClient
    // Client Details tab for EditClientPage
    export default {
        name: "ClientDetails",
        props: {
            clientInfo: Object,
            otherFields: Boolean
        },
        data() {
            return {
                valid: false,
                deleteDialog: false,
                toBeDeleted: {name: null},
                inputValid: false,
                phoneRule: [
                    v => !!v || 'Phone is required',
                    v => /^(\+\d{2}[ \-]{0,1}){0,1}(((\({0,1}[ \-]{0,1})0{0,1}\){0,1}[2|3|7|8]{1}\){0,1}[ \-]*(\d{4}[ \-]{0,1}\d{4}))|(1[ \-]{0,1}(300|800|900|902)[ \-]{0,1}((\d{6})|(\d{3}[ \-]{0,1}\d{3})))|(13[ \-]{0,1}([\d \-]{5})|((\({0,1}[ \-]{0,1})0{0,1}\){0,1}4{1}[\d \-]{8,10})))$/.test(v) || 'Phone must be valid'
                ],
                emailRule: [
                    v => !!v || 'This field is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ],
                requiredRule: [
                    v => !!v || 'This field is required'
                ],
                headers: [
                    {text: 'Contact', value: 'name', sortable: false, align: 'left'},
                    {text: 'Ops', value: 'ops', sortable: false, align: 'left'},
                    {text: 'CC', value: 'cc', sortable: false, align: 'left'},
                    {text: 'IT', value: 'it', sortable: false, align: 'left'},
                    {text: 'Billing', value: 'billing', sortable: false, align: 'left'},
                    {text: 'Phone', value: 'phone', sortable: false, mask: '+## ###-###-###', align: 'left'},
                    {text: 'Email', value: 'email', sortable: false, align: 'left', mask: null},
                    {text: 'Actions', sortable: false, align: 'left', width: '2%'},
                ],
                editedItem: {
                    client_id: this.clientInfo.id,
                    client_name: this.clientInfo.name,
                    name: null,
                    ops: false,
                    cc: false,
                    it: false,
                    billing: false,
                    phone: null,
                    email: null
                },
                defaultItem: {
                    client_id: this.clientInfo.id,
                    client_name: this.clientInfo.name,
                    name: null,
                    ops: false,
                    cc: false,
                    it: false,
                    billing: false,
                    phone: null,
                    email: null
                },
                items: [
                    {text: 'Contact 1', key: 'contact1'},
                    {text: 'Position', key: 'contact1_position'},
                    {text: 'Phone', key: 'contact1_phone'},
                    {text: 'Email', key: 'contact1_email'},
                    {text: 'Contact 2', key: 'contact2'},
                    {text: 'Position', key: 'contact2_position'},
                    {text: 'Phone', key: 'contact2_phone'},
                    {text: 'Email', key: 'contact2_email'},
                    {text: 'CC Contact', key: 'cc_contact'},
                    {text: 'CC Contact Phone', key: 'cc_contact_phone'},
                    {text: 'CC Contact Email', key: 'cc_contact_email'},
                ],
                email: null,
                newContactDialog: false,
                contacts: [],
            }
        },
        methods: {
            // @vuese
            // Get contacts of the client (ops, billing, it, cc ...)
            getContacts() {
                axios.get(process.env.API_URL + '/clients/' + this.clientInfo.id + '/contacts')
                    .then((response) => {
                        this.contacts = response.data;
                    })
                    .catch((response) => {
                        // Displays error message in snackbar
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Check if at least one position is ticked
            save() {
                if (this.$refs.newContactForm.validate()) {
                    if (this.editedItem.ops || this.editedItem.billing || this.editedItem.it || this.editedItem.cc) {
                        axios.post(process.env.API_URL + '/clients/' + this.clientInfo.id + '/contacts', this.editedItem)
                            .then((response) => {
                                this.contacts.unshift(response.data);
                                // Displays error message in snackbar
                                this.$store.commit('displaySnackbar', 'Contact "' + response.data.name + '" created');
                                this.editedItem = Object.assign({}, this.defaultItem);
                                this.newContactDialog = false;
                            })
                            .catch((response) => {
                                // Displays error message in snackbar
                                this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);

                            })
                    } else {
                        // Displays error message in snackbar if no position has been ticked in contact table
                        this.$store.commit('displaySnackbar', 'Please make sure at least one position has been ticked.');
                    }
                } else {
                    // Displays error message in snackbar if some fields are empty in contact table
                    this.$store.commit('displaySnackbar', 'Please fill all the fields');
                }
            },
            // @vuese
            // Saves changes on a contact of the contact table of the client.
            // @arg The argument is a contact object
            editSave(item) {
                axios.put(process.env.API_URL + '/clients/' + this.clientInfo.id + '/contacts/' + item.id, item)
                    .then((response) => {
                        Object.assign(item, response.data);
                        this.$store.commit('displaySnackbar', 'Contact "' + response.data.name + '" edited');
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Opens delete confirmation dialog for the client contacts.
            // @arg The argument is a contact Object
            openDeleteDialog(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            // @vuese
            // Closes delete confirmation dialog and resets toBeDeleted to default.
            closeDeleteDialog() {
                this.toBeDeleted = {name: null};
                this.deleteDialog = false;
            },
            // @vuese
            // Calls the API to delete toBeDeleted contact.
            deleteItem() {
                axios.delete(process.env.API_URL + '/clients/' + this.clientInfo.id + '/contacts/' + this.toBeDeleted.id)
                    .then((response) => {
                        let index = this.contacts.indexOf(this.toBeDeleted);
                        this.contacts.splice(index, 1);
                        this.$store.commit('displaySnackbar', 'Contact "' + this.toBeDeleted.name + '" deleted.');
                        this.closeDeleteDialog();
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            }
        },
        computed: {
            editPermission() {
                return this.$store.getters['auth/hasPermission']('client_edit');
            }
        },
        mounted() {
            this.getContacts();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientDetails.vue